import { useState, useCallback } from 'react';

export const useSlotMachine = () => {
  const [animationData, setAnimationData] = useState({
    isVisible: false,
    type: 'points',
    oldValue: 0,
    newValue: 0,
    rewardName: '',
    duration: 3000
  });

  const showPointsAnimation = useCallback((oldPoints, newPoints, duration = 3000) => {
    // Primeiro esconder qualquer animação existente
    setAnimationData(prev => ({ ...prev, isVisible: false }));
    
    // Depois de um pequeno delay, mostrar a nova animação
    setTimeout(() => {
      setAnimationData({
        isVisible: true,
        type: 'points',
        oldValue: oldPoints,
        newValue: newPoints,
        rewardName: '',
        duration
      });
    }, 50);
  }, []);

  const showRewardAnimation = useCallback((oldPoints, newPoints, rewardName, duration = 3000) => {
    // Primeiro esconder qualquer animação existente
    setAnimationData(prev => ({ ...prev, isVisible: false }));
    
    // Depois de um pequeno delay, mostrar a nova animação
    setTimeout(() => {
      setAnimationData({
        isVisible: true,
        type: 'reward',
        oldValue: oldPoints,
        newValue: newPoints,
        rewardName,
        duration
      });
    }, 50);
  }, []);

  const hideAnimation = useCallback(() => {
    setAnimationData(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  const resetAnimation = useCallback(() => {
    setAnimationData({
      isVisible: false,
      type: 'points',
      oldValue: 0,
      newValue: 0,
      rewardName: '',
      duration: 3000
    });
  }, []);

  return {
    animationData,
    showPointsAnimation,
    showRewardAnimation,
    hideAnimation,
    resetAnimation
  };
};
